import { useEffect } from "react";

const ARTWORK_URL = `${window.location.origin}/icon-512.png`;

// Wires the Media Session API so narration play/pause/skip work from the
// phone's lock screen / notification while audio plays in the background.
export default function useMediaSession({
  title,
  artist = "DreamWeaver",
  isPlaying,
  onPlayPause,
  onSeekBackward,
  onSeekForward,
  onPreviousTrack,
  onNextTrack,
}) {
  useEffect(() => {
    if (!("mediaSession" in navigator) || !title) return;
    navigator.mediaSession.metadata = new window.MediaMetadata({
      title,
      artist,
      album: "DreamWeaver Bedtime Stories",
      artwork: [{ src: ARTWORK_URL, sizes: "512x512", type: "image/png" }],
    });
    navigator.mediaSession.playbackState = isPlaying ? "playing" : "paused";
  }, [title, artist, isPlaying]);

  useEffect(() => {
    if (!("mediaSession" in navigator)) return;
    const setHandler = (action, handler) => {
      try { navigator.mediaSession.setActionHandler(action, handler); } catch { /* unsupported in this browser */ }
    };
    setHandler("play", onPlayPause || null);
    setHandler("pause", onPlayPause || null);
    setHandler("seekbackward", onSeekBackward || null);
    setHandler("seekforward", onSeekForward || null);
    setHandler("previoustrack", onPreviousTrack || null);
    setHandler("nexttrack", onNextTrack || null);
    return () => {
      ["play", "pause", "seekbackward", "seekforward", "previoustrack", "nexttrack"].forEach((a) => setHandler(a, null));
    };
  }, [onPlayPause, onSeekBackward, onSeekForward, onPreviousTrack, onNextTrack]);
}

export function updateMediaSessionPosition(duration, position) {
  if (!("mediaSession" in navigator) || !("setPositionState" in navigator.mediaSession)) return;
  if (!isFinite(duration) || duration <= 0) return;
  try {
    navigator.mediaSession.setPositionState({ duration, playbackRate: 1, position: Math.min(position, duration) });
  } catch { /* browser rejected an out-of-range value mid-seek */ }
}
